import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/hero";

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);
  const total = heroSlides.length;

  const goTo = useCallback((index: number) => {
    setCurrent((index + total) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % total);
    }, 6000);
    return () => clearInterval(timer);
  }, [total]);

  return (
    <section className="relative w-full overflow-hidden bg-primary-950">
      <div className="relative h-[360px] w-full md:h-[520px]">
        {heroSlides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              index === current ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
          >
            <img
              src={slide.image}
              alt={`${slide.title} - 棒棒TV精选影视推荐`}
              title={`${slide.title} - 棒棒TV`}
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-primary-950/20"></div>
            <div className="absolute inset-0 flex items-center">
              <div className="w-full px-4 md:px-8">
                <div className="max-w-2xl">
                  <span className="inline-flex items-center rounded-md bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
                    {slide.tag}
                  </span>
                  <h1 className="mt-4 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
                    {slide.title}
                  </h1>
                  <p className="mt-2 text-sm font-medium text-secondary-300 md:text-base">
                    {slide.subtitle}
                  </p>
                  <p className="mt-3 hidden max-w-xl text-sm leading-relaxed text-background-200 sm:block">
                    {slide.description}
                  </p>
                  <div className="mt-6 flex flex-wrap items-center gap-3">
                    <Link
                      to={slide.link}
                      className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
                    >
                      <i className="ri-play-circle-line text-lg"></i>
                      查看详情
                    </Link>
                    <Link
                      to="/special"
                      className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
                    >
                      浏览专题
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        <button
          type="button"
          onClick={() => goTo(current - 1)}
          className="absolute left-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-primary-950/50 text-background-50 transition-colors hover:bg-accent-500 md:left-6 md:h-10 md:w-10 cursor-pointer"
          aria-label="上一张"
        >
          <i className="ri-arrow-left-s-line text-xl"></i>
        </button>
        <button
          type="button"
          onClick={() => goTo(current + 1)}
          className="absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-primary-950/50 text-background-50 transition-colors hover:bg-accent-500 md:right-6 md:h-10 md:w-10 cursor-pointer"
          aria-label="下一张"
        >
          <i className="ri-arrow-right-s-line text-xl"></i>
        </button>

        <div className="absolute bottom-4 left-1/2 flex -translate-x-1/2 items-center gap-2">
          {heroSlides.map((slide, index) => (
            <button
              key={slide.id}
              type="button"
              onClick={() => goTo(index)}
              aria-label={`切换到第 ${index + 1} 张`}
              className={`h-1.5 rounded-full transition-all cursor-pointer ${
                index === current ? "w-8 bg-accent-500" : "w-3 bg-background-50/50"
              }`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
}